
import React from 'react';
import { Check } from 'lucide-react';

const CtoServiceBenefits = () => {
  const testimonials = [
    {
      quote: "18 % weniger IT-Kosten und die Projekte laufen schneller. Für uns ein echter Gewinn.",
      author: "Laura Ritter, MedTech-Start GmbH"
    },
    {
      quote: "Endlich verstehe ich, wofür wir zahlen – und bekomme bessere Konditionen bei unseren Anbietern.",
      author: "Thomas Schubert, Faber Logistic AG"
    }
  ];

  const comparison = [
    {
      category: "Startklar in",
      internal: "4–6 Monaten",
      external: "< 2 Wochen"
    },
    {
      category: "Fixkosten",
      internal: "> 120 k €/Jahr",
      external: "Planbarer Monats­betrag"
    },
    {
      category: "Wissen",
      internal: "1 Person",
      external: "Ganzes Experten­team"
    },
    {
      category: "Urlaubs­ausfall",
      internal: "Risiko",
      external: "Abgedeckt"
    },
    {
      category: "Anbieter­neutral",
      internal: "Variiert",
      external: "Ja"
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Das sagen unsere Kunden</h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <p className="italic text-gray-700 mb-4">"{testimonial.quote}"</p>
              <p className="font-medium text-blue-700">{testimonial.author}</p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Interner IT-Leiter vs. Externe IT-Leitung</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-4 text-left border-b-2 border-gray-200"></th>
                  <th className="p-4 text-left border-b-2 border-gray-200">Interne Stelle</th>
                  <th className="p-4 text-left border-b-2 border-gray-200">Unser Service</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((item, index) => (
                  <tr key={index} className="border-b border-gray-100">
                    <td className="p-4 font-medium">{item.category}</td>
                    <td className="p-4">{item.internal}</td>
                    <td className="p-4 font-medium text-blue-700">{item.external}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtoServiceBenefits;
